let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("CwkI6")).then(() => parcelRequire('b5mgb'));